import { type FC, useCallback } from 'react';

import { useMortgageCalculatorContext } from '../../contexts/MortgageCalculatorContext';
import { trackMortgageOffersTabClick } from '../MortgageSection/tracking';

import { SeoMortgageLink } from './SeoMortgageLink';

export const SeoMortgageLinkContainer: FC = () => {
  const { mortgageSeoPageUrl } = useMortgageCalculatorContext();

  const onClick = useCallback(() => {
    trackMortgageOffersTabClick('seoUrl');
  }, []);

  if (!mortgageSeoPageUrl) {
    return null;
  }

  return (
    <SeoMortgageLink
      testId="seo_mortgage_link"
      title="Ипотечные предложения и аккредитованные банки"
      url={mortgageSeoPageUrl}
      onClick={onClick}
    />
  );
};
